import React, { useContext } from "react"
import TotalBets from "./totalBets/TotalBets"
import TextInfo from "./textInfo/TextInfo"
import { MainBoard } from "./GameBoardStyle"
import JackpotHeader from "../../modals/jackpot/header/Header"
import { AppContext } from "../../context/createContext"

export default function GameBoard({
  removeComponents,
  tempRemoveComponents,
  jackpotPopup,
  isLoading,
  isJackpot,
}: any) {
  const { jackpotInfo }: any = useContext(AppContext)

  return (
    <MainBoard removeComponent={removeComponents} jackpotPopup={jackpotPopup}>
      <JackpotHeader
        tempRemoveComponents={tempRemoveComponents}
        jackpotPopup={jackpotPopup}
        isLoading={isLoading}
        isJackpot={isJackpot}
      />
      {!jackpotPopup && (
        <div className="info">
          <TotalBets jackpot={jackpotInfo.items} />
          <TextInfo />
        </div>
      )}
    </MainBoard>
  )
}
